import React, { useState } from "react";
import { LayoutPage } from "../../components/Layout/layoutPage";
import TopBar from "../../components/TopBar/TopBar";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import * as yup from "yup";
import { InputCustom } from "../../components/Input/InputCustom";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuthApi } from "../../api/AuthApi";
import { useDispatch, useSelector } from "react-redux";
import { importBaseActions } from "../../store/reducers/base";
import TopBarMinimal from "../../components/TopBar/TopBarMinimal";

/* =======================
   VALIDATION SCHEMA
======================= */
const validationSchema = yup.object({
  email: yup
    .string()
    .email("Il formato email non è corretto")
    .required("Email obbligatoria"),
});

/* =======================
   COMPONENT
======================= */
export const ConfermaEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const baseState = useSelector((state) => state.base);
  const authApi = useAuthApi();
  const dispatch = useDispatch();
  const baseActions = importBaseActions();

  const [email, setEmail] = useState(baseState.user.email);
  const [error, setError] = useState("");
  const [isBusy, setIsBusy] = useState(false);
  const [message, setMessage] = useState("");

  /* =======================
     VALIDATE EMAIL
  ======================= */
  const validateEmail = async (value) => {
    try {
      await validationSchema.validateAt("email", { email: value });
      setError("");
      return true;
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        setError(err.message);
      }
      return false;
    }
  };

  /* =======================
     HANDLE CHANGE
  ======================= */
  const handleEmailChange = async (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value.trim()) {
      setError("Email obbligatoria");
      return;
    }

    await validateEmail(value);
  };

  /* =======================
     HANDLE SUBMIT
  ======================= */
  const handleSubmit = async () => {
    const isValid = await validateEmail(email);
    if (!isValid) return;

    setIsBusy(true);

    try {
      let res = await authApi.changeEmail(
        baseState.user.token,
        baseState.user.id,
        baseState.user.userType,
        email
      );

      console.log("RES", res);

      if (res.message !== "Success") {
        setError(res.message);
      } else {
        setMessage("Email confermata con successo");
        navigate("/configurations");
      }
    } catch (e) {
      setError("Errore durante la conferma email");
    } finally {
      setIsBusy(false);
    }
  };

  /* =======================
     RENDER
  ======================= */
  return (
    <LayoutPage>
      <div style={{ flex: "0 0 auto" }}>
        <TopBarMinimal />

        <div className="d-flex justify-content-between p-3">
          <h2 className="h2 fw-bold">Conferma la tua email</h2>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/")}
          >
            <CloseIcon />
            <span className="ms-2">CHIUDI</span>
          </Button>
        </div>

        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <InputCustom
                name="email"
                label="La tua email"
                type="email"
                placeholder="esempio@dominio.it"
                value={email}
                error={!!error}
                helperText={error}
                onChange={handleEmailChange}
                multiline={false}
                rows={1}
                hidden={false}
                InputProps={{}}
                sx={{}}
                disabled={false}
                onFocus={() => {}}
                onBlur={() => {}}
                size="medium"
              />

              <div className="text-end mt-4">
                {isBusy ? (
                  <CircularProgress size={32} />
                ) : (
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleSubmit}
                    disabled={!email}
                  >
                    Conferma email
                  </Button>
                )}
              </div>

              {message && (
                <div className="text-success mt-3 text-end">{message}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </LayoutPage>
  );
};